/**
 * Development-only feature flags.
 *
 * `process.env.NODE_ENV` is replaced with a literal at build time by CRA, so a branch guarded on
 * `=== 'development'` is dead code in a production build and Terser removes it entirely. Anything
 * gated here is therefore ABSENT from the shipped bundle — not merely hidden behind a flag a
 * curious user could flip.
 *
 * Keep the check in this one place so it cannot drift between call sites.
 */

/** True only on a dev server (`npm start`) AND with `?debug` in the URL. */
export function isReadDebugEnabled(): boolean {
  if (process.env.NODE_ENV !== 'development') return false;
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).has('debug');
}
